import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import IndexPage from 'flarum/forum/components/IndexPage';
import PagePagePC from './PagePagePC';
import PagePage from '../../common/models/PagePage';
import DiscussionList from 'flarum/forum/components/DiscussionList';
import Button from 'flarum/components/Button';
import listItems from 'flarum/common/helpers/listItems';
import ItemList from 'flarum/common/utils/ItemList';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
import LinkButton from 'flarum/common/components/LinkButton';
import sortTags from 'flarum/tags/common/utils/sortTags';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import FloatPostButton from '../../common/components/FloatPostButton';
import NavigationBar from './NavigationBar';
import DiscussionPage from 'flarum/common/components/DiscussionPage';
import LogInModal from 'flarum/forum/components/LogInModal';

//主页
export default class TagViewPC extends Page {
  lastDiscussion;
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'App--page';
    this.loading = true;
    this.tags = [];
    this.tagItem = [];
    this.localeName = '';
    this.localeMainImgUrl = '';
    if (app.previous.matches(DiscussionPage)) {
      this.lastDiscussion = app.previous.get('discussion');
    }
    app.tagList
      .load([
        'children',
        'lastPostedDiscussion',
        'parent',
        'wikiLabel',
        'wikiLabel.wikiLabelOptions',
        'wikiLabel.wikiLabelOptions.wikiLabelOptionsSon',
        'wikiHeroDetailDiscussion', 'heroTagLatestdata' ,'heroTagLatestdata.heroTagHeroIntro' ,'heroTagLatestdata.heroTagHeroIntro.heroTagHeroLevel'
      ])
      .then(() => {
        this.tags = sortTags(app.store.all('tags').filter((tag) => !tag.isChild() && tag.pkgId() == app.data.pkgLogo.id));
        const pinned = this.tags.filter((tag) => tag.position() !== null);
        this.tagItem = pinned.filter((tag) => {
          return this.attrs.tags === tag.slug();
        });
        if (this.tagItem.length > 0) {
          let name = this.tagItem[0]?.name();
          if (name) {
            // 将字符串映射转换为 JavaScript 对象
            const obj = JSON.parse(name);
            // 创建 Map 对象并初始化
            const map = new Map(Object.entries(obj));
            // 获取特定键的值
            this.localeName = map.get(app.data.locale);
            app.setTitle(this.localeName);
          }
          let mainImgUrl = this.tagItem[0]?.mainImgUrl();
          if (mainImgUrl) {
            // 将字符串映射转换为 JavaScript 对象
            const obj = JSON.parse(mainImgUrl);
            // 创建 Map 对象并初始化
            const map = new Map(Object.entries(obj));
            const objPc = map.get('pc');
            // 获取特定键的值
            this.localeMainImgUrl = objPc[app.data.locale];
          }
        }
        this.loading = false;
        m.redraw();
      });

    sessionStorage.setItem('tagItem', this.attrs.tags);
    app.discussions.refreshParams(app.search.params(), (m.route.param('page') && Number(m.route.param('page'))) || 1);
    app.history.push(`t/${this.attrs.tags}`, app.translator.trans('flarum-tags.forum.header.back_to_tags_tooltip'));
    if (!app.cache.heroHeight) {
      app.cache.heroHeight = {};
    }
    if (!app.cache.scrollTop) {
      app.cache.scrollTop = {};
    }
  }
  oncreate(vnode) {
    super.oncreate(vnode);

    // Work out the difference between the height of this hero and that of the
    // previous hero. Maintain the same scroll position relative to the bottom
    // of the hero so that the sidebar doesn't jump around.
    const oldHeroHeight = app.cache.heroHeight['TagViewPC'];
    const heroHeight = (app.cache.heroHeight['TagViewPC'] = this.$('.Hero').outerHeight() || 0);
    const scrollTop = app.cache.scrollTop[`TagViewPC${this.attrs.tags}`];
    $('#app').css('min-height', ($(window).height() || 0) + scrollTop);

    // Let browser handle scrolling on page reload.
    if (app.previous.type == null) return;

    // Only retain scroll position if we're coming from a discussion page.
    // Otherwise, we've just changed the filter, so we should go to the top of the page.
    if (this.lastDiscussion || scrollTop) {
      $(window).scrollTop(scrollTop - oldHeroHeight);
    } else {
      $(window).scrollTop(0);
    }
    if (this.lastDiscussion) {
      const $discussion = this.$(`li[data-id="${this.lastDiscussion.id()}"] .DiscussionListItem`);

      if ($discussion.length) {
        const indexTop = $('#app-navigation').outerHeight() || 0;

        const indexBottom = $(window).height() || 0;
        const discussionOffset = $discussion.offset();
        const discussionTop = (discussionOffset && discussionOffset.top) || 0;
        const discussionBottom = discussionTop + ($discussion.outerHeight() || 0);

        if (discussionTop < scrollTop + indexTop || discussionBottom > scrollTop + indexBottom) {
          $(window).scrollTop(discussionTop - indexTop);
        }
      }
    }
  }

  onbeforeremove(vnode) {
    super.onbeforeremove(vnode);

    // Save the scroll position so we can restore it when we return to the
    // discussion list.
    app.cache.scrollTop[`TagViewPC${this.attrs.tags}`] = $(window).scrollTop();
  }
  onremove(vnode) {
    super.onremove(vnode);

    $('#app').css('min-height', '');
  }

  title() {
    return <h4 className="App-titleControl tagTitle">{listItems(this.items().toArray())}</h4>;
  }

  items() {
    const items = new ItemList();
    if (this.loading) {
      items.add('loading', <LoadingIndicator />);
    }
    const pinned = this.tags.filter((tag) => tag.position() !== null);
    if (pinned) {
      items.add(
        'title',
        <div className="dl-header-tabs">
          <NavigationBar />
        </div>
      );
    }

    return items;
  }

  view() {
    let url = app.forum.attribute('baseUrl');

    const centerOnClick = (event) => {
      // if (!app.session.user) {
      //   event.preventDefault();
      //   app.modal.show(LogInModal);
      //   return;
      // }
    };
    return (
      <main class="App-content">
        {this.title()}
        <div id="content">
          <div className="TagsPage">
            <div className="dl-content">
              <div className="dl_tag_image image-placeholder">
                {this.tagItem.length > 0 && (
                  <a
                    href={
                      this.tagItem[0].mainImgJumpUrl()
                        ? this.tagItem[0].mainImgJumpUrl() &&
                          (this.tagItem[0].mainImgJumpUrl().includes('http')
                            ? this.tagItem[0].mainImgJumpUrl()
                            : url + this.tagItem[0].mainImgJumpUrl())
                        : '#'
                    }
                    onclick={centerOnClick}
                  >
                    <img
                      class="carousel__slide-image"
                      src={this.localeMainImgUrl}
                      onload={function () {
                        this.classList.remove('lazy');
                        this.classList.add('lazy-loaded');
                      }}
                    />
                  </a>
                )}
                <div class="separator"></div>
              </div>
              <div className="IndexPage-toolbar-box">
                <div className="IndexPage-toolbar dl-discussion-container">
                  <div className="IndexPage-toolbar-lin">
                    <ul className="IndexPage-toolbar-view">{listItems(IndexPage.prototype.viewItems().toArray())}</ul>
                    <ul className="IndexPage-toolbar-action">{listItems(IndexPage.prototype.actionItems().toArray())}</ul>
                  </div>
                  <DiscussionList state={app.discussions} isAllTag={this.tagItem.length > 0 && this.tagItem[0].isAllTag()} />
                </div>
              </div>
            </div>
          </div>
        </div>
        {!app.session.user?.isSuspended() && this.tagItem.length > 0 && this.tagItem[0].canStartDiscussion() && <FloatPostButton />}
      </main>
    );
  }
}
